import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
let default_1 = class default_1 extends Vue {
    title;
    time;
    disabled;
    ruleForm = {
        time: this.$props.time,
    };
    get rules() {
        return {
            time: [
                { required: true, message: '0-99,999,999', trigger: 'blur' },
                {
                    validator: (rule, value, callback) => {
                        const reg = /^(0|\+?[1-9][0-9]{0,7})$/;
                        if (!reg.test(value)) {
                            callback(new Error('0-99,999,999'));
                        }
                        else {
                            callback();
                        }
                    },
                    trigger: 'blur',
                },
            ],
        };
    }
    changeTime(val) {
        this.$emit('update:time', val);
    }
    isValidate() {
        let isValidate = null;
        this.$refs.ruleForm.validate((valid) => {
            if (valid) {
                isValidate = true;
            }
            else {
                isValidate = false;
            }
        });
        return isValidate;
    }
};
__decorate([
    Prop()
], default_1.prototype, "title", void 0);
__decorate([
    Prop()
], default_1.prototype, "time", void 0);
__decorate([
    Prop({ default: false, type: Boolean })
], default_1.prototype, "disabled", void 0);
default_1 = __decorate([
    Component({
        name: 'InitialVisitorNumber',
        components: {},
        i18n: {
            messages: {
                zh: {},
                'en-us': {},
            },
        },
    })
], default_1);
export default default_1;
